const moneda = 'L';

export default moneda;
